import React from "react";
import ContentLoader from "react-content-loader";

const SkeletonSelectedColors = (props) => (
  <ContentLoader
    speed={2}
    width={1290}
    height={277}
    viewBox="0 0 1290 277"
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
    {...props}
  >
    <rect x="0" y="20" rx="0" ry="0" width="150.5" height="120" />
    <rect x="155.5" y="20" rx="0" ry="0" width="150.5" height="36.67" />
    <rect x="155.5" y="61.62" rx="0" ry="0" width="150.5" height="36.67" />
    <rect x="155.5" y="103.24" rx="0" ry="0" width="150.5" height="36.67" />
    <rect x="0" y="153" rx="0" ry="0" width="191.5" height="18" />
    <rect x="0" y="185" rx="0" ry="0" width="151" height="28" />
    <rect x="155" y="185" rx="0" ry="0" width="151" height="28" />
    <rect x="0" y="217" rx="0" ry="0" width="151" height="28" />
    <rect x="155" y="217" rx="0" ry="0" width="151" height="28" />
    <rect x="0" y="249" rx="0" ry="0" width="151" height="28" />
    <rect x="155" y="249" rx="0" ry="0" width="151" height="28" />
    <rect x="326" y="20" rx="0" ry="0" width="150.5" height="120" />
    <rect x="481.5" y="20" rx="0" ry="0" width="150.5" height="36.67" />
    <rect x="481.5" y="61.62" rx="0" ry="0" width="150.5" height="36.67" />
    <rect x="481.5" y="103.24" rx="0" ry="0" width="150.5" height="36.67" />

    <rect x="326" y="153" rx="0" ry="0" width="191.5" height="18" />
    <rect x="326" y="185" rx="0" ry="0" width="151" height="28" />
    <rect x="481" y="185" rx="0" ry="0" width="151" height="28" />
    <rect x="326" y="217" rx="0" ry="0" width="151" height="28" />
    <rect x="481" y="217" rx="0" ry="0" width="151" height="28" />
    <rect x="326" y="249" rx="0" ry="0" width="151" height="28" />
    <rect x="481" y="249" rx="0" ry="0" width="151" height="28" />

    <rect x="652" y="20" rx="0" ry="0" width="150.5" height="120" />
    <rect x="807.5" y="20" rx="0" ry="0" width="150.5" height="36.67" />
    <rect x="807.5" y="61.62" rx="0" ry="0" width="150.5" height="36.67" />
    <rect x="807.5" y="103.24" rx="0" ry="0" width="150.5" height="36.67" />
    <rect x="652" y="153" rx="0" ry="0" width="191.5" height="18" />
    <rect x="652" y="185" rx="0" ry="0" width="151" height="28" />
    <rect x="807" y="185" rx="0" ry="0" width="151" height="28" />
    <rect x="652" y="217" rx="0" ry="0" width="151" height="28" />
    <rect x="807" y="217" rx="0" ry="0" width="151" height="28" />
    <rect x="652" y="249" rx="0" ry="0" width="151" height="28" />
    <rect x="807" y="249" rx="0" ry="0" width="151" height="28" />

    <rect x="978" y="20" rx="0" ry="0" width="150.5" height="120" />
    <rect x="1133.5" y="20" rx="0" ry="0" width="150.5" height="36.67" />
    <rect x="1133.5" y="61.62" rx="0" ry="0" width="150.5" height="36.67" />
    <rect x="1133.5" y="103.24" rx="0" ry="0" width="150.5" height="36.67" />
    <rect x="978" y="153" rx="0" ry="0" width="191.5" height="18" />
    <rect x="978" y="185" rx="0" ry="0" width="151" height="28" />
    <rect x="1133" y="185" rx="0" ry="0" width="151" height="28" />
    <rect x="978" y="217" rx="0" ry="0" width="151" height="28" />
    <rect x="1133" y="217" rx="0" ry="0" width="151" height="28" />
    <rect x="978" y="249" rx="0" ry="0" width="151" height="28" />
    <rect x="1133" y="249" rx="0" ry="0" width="151" height="28" />

    <rect x="1287" y="20" rx="1" ry="1" width="3" height="67" />
  </ContentLoader>
);

export default SkeletonSelectedColors;
